import { render, staticRenderFns } from "./SectionAccordion.vue?vue&type=template&id=38f400e9"
import script from "./SectionAccordion.vue?vue&type=script&lang=js"
export * from "./SectionAccordion.vue?vue&type=script&lang=js"
import style0 from "./SectionAccordion.vue?vue&type=style&index=0&id=38f400e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports